import Vue from 'vue'
import vueRouter from 'vue-router'
import { routes } from './routes'
const originalPush = vueRouter.prototype.push; 
vueRouter.prototype.push = function push(location) { return originalPush.call(this, location).catch(err => err) };
Vue.use(vueRouter)
export const router = new vueRouter({
    routes,
    mode: 'history'
});


// WEBPACK FOOTER //
// ./src/router/router.js